import { createSlice } from '@reduxjs/toolkit';

const ecclesialDocSlice = createSlice({
  name: 'ecclesialDocs',
  initialState: {
    isUploading: false,
    uploadProgress: {},
    uploadErrors: [],
    uploadedDocumentIds: []
  },
  reducers: {
    setUploading: (state, action) => {
      state.isUploading = action.payload;
    },
    setUploadProgress: (state, action) => {
      const { uid, progress } = action.payload;
      state.uploadProgress[uid] = progress;
    },
    setUploadError: (state, action) => {
      state.uploadErrors.push(action.payload);
    },
    addUploadedDocumentId: (state, action) => {
      state.uploadedDocumentIds.push(action.payload);
    },
    resetState: (state) => {
      state.isUploading = false;
      state.uploadProgress = {};
      state.uploadErrors = [];
      state.uploadedDocumentIds = [];
    }
  }
});

export const {
  setUploading,
  setUploadProgress,
  setUploadError,
  addUploadedDocumentId,
  resetState
} = ecclesialDocSlice.actions;

export default ecclesialDocSlice.reducer;